import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Grape } from "lucide-react";

const C = { bg: "#F7F4EF", borgona: "#5A1E2C", oro: "#C8A96A", texto: "#222222", gris: "#777777" };

export function LegalLayout({ title, updated, children }) {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div style={{ background: C.bg, color: C.texto }} className="min-h-screen font-sans">
      <header className="border-b border-black/5" style={{ background: "#fff" }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 py-5 flex items-center justify-between">
          <button data-testid="legal-back-btn" onClick={() => (window.history.length > 1 ? navigate(-1) : navigate("/"))} className="flex items-center gap-1.5 text-sm font-medium transition-colors hover:opacity-70" style={{ color: C.borgona }}>
            <ArrowLeft className="w-4 h-4" /> Volver
          </button>
          <a href="/" className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-lg flex items-center justify-center" style={{ background: C.borgona }}>
              <Grape className="w-4 h-4" style={{ color: C.oro }} />
            </span>
            <span className="font-serif text-lg" style={{ color: C.borgona }}>Vinonotas</span>
          </a>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-12 sm:py-16">
        <p className="text-xs uppercase tracking-[0.25em] mb-3" style={{ color: C.oro }}>Legal</p>
        <h1 className="font-serif text-4xl sm:text-5xl mb-3" style={{ color: C.borgona }}>{title}</h1>
        {updated && <p className="text-sm mb-10" style={{ color: C.gris }}>Última actualización: {updated}</p>}
        <div className="legal-content space-y-6 leading-relaxed">{children}</div>

        <p className="mt-14 pt-6 border-t border-black/10 text-xs" style={{ color: C.gris }}>
          Este documento es una plantilla informativa de carácter general y no constituye asesoramiento legal.
          Vinonotas recomienda beber con moderación. La venta de alcohol a menores de edad está prohibida.
        </p>
      </main>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="font-serif text-2xl mb-2" style={{ color: C.texto }}>{title}</h2>
      <div className="text-[15px] space-y-3" style={{ color: "#444" }}>{children}</div>
    </section>
  );
}
